<template>
  <el-form ref="form" :model="form" class="form_flex">
    <el-form-item prop="status">
      <el-select
        class="search-select1"
        v-model="roleName"
        placeholder="请选择状态"
        @change="changeRole"
      >
        <el-option
          v-for="(item, index) in rolesList"
          :key="index"
          :label="item.roleName"
          :value="item.roleId"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item prop="userName">
      <el-select
        class="select"
        v-model="form.userName"
        filterable
        remote
        placeholder="请输入用户名"
        :remote-method="searchUser"
        @change="checkItem"
        clearable
        :loading="loading"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
          :value="item.label"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="mobile">
      <el-input
        class="search-input"
        v-model="form.mobile"
        placeholder="请输入账号"
      ></el-input>
    </el-form-item>
    <el-form-item class="btn">
      <el-button @click="onSearch" icon="el-icon-search" size="small"
        >查询</el-button
      >
      <el-button size="small" @click="resetForm('form')" type="error"
        >清空</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
      <PermissionsBtn
        :icon="'el-icon-download'"
        :btnType="'primary'"
        :permissionName="'_Export'"
        :downloadUrl="'/userAdmin/Home/downLoad'"
        :checkList="checkList"
        :form="form"
      ></PermissionsBtn>
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="onAdd"
        type="primary"
        v-if="roleList[path].includes('_Add')"
        >新增</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    // rolesList: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      // searchRolesList: [{ roleName: '全部', roleType: '' }],
      rolesList: [],
      // 表单内容
      form: {
        userName: '',
        mobile: '',
        roleType: '',
      },
      roleName: '',
      path: '',
      options: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {},
  methods: {
    // 点击下拉数据
    changeRole(val) {
      // console.log('选中的值：', val, this.rolesList);
      this.form.roleType = val;
    },

    // 搜索，触发父组件请求数据的方法
    async onSearch() {
      this.$emit('search', this.form);
    },

    // 搜索用户名
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择用户名下拉选项
    checkItem(val) {
      this.form.userName = val;
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$emit('openAddAuth', true);
    },

    // 清空表单
    resetForm(formName) {
      this.roleName = '';
      this.form.roleType = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 170px;
}

.search-select1 {
  width: 120px;
}

.select {
  margin-left: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
